"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CheckButton", {
  enumerable: true,
  get: function get() {
    return _CheckButton["default"];
  }
});
var _CheckButton = _interopRequireDefault(require("./CheckButton"));